module.exports = __webpack_public_path__ + "img/icon_10.7b6a5e4b.svg";